import {NavLink, useLocation} from "react-router-dom";
import {useState} from "react";
import {useSelector} from "react-redux";

export default function SidebarItem(props) {

    const {
        title = "",
        url = "/",
        hasNotification,
        notificationClass,
        subMenu = [],
        opened,
        iconClass = "",
        activeInMenu,
        layout = {}
        // path,
    } = props;

    const {pathname} = useLocation();
    const [showSubmenu, setShowSubmenu] = useState(false);
    const activeAccount = useSelector(state => state.user.activeAccount);

    return (
        <div className="relative">
            {
                hasNotification && layout[hasNotification] ?
                    <span
                        className={`absolute z-10 w-[0.563rem] h-[0.563rem] rounded-full top-px -right-[0.281rem] ${notificationClass}`}/>
                    : null
            }
            {
                subMenu.length && (activeAccount || activeInMenu === null) ?
                    <div className="w-full">
                        <div className={`group flex-between w-full ${pathname === url ? "active" : ""}`}>

                            <NavLink to={url}
                                     className="flex items-center flex-grow gap-x-2.5">
                                <div
                                    className="pol-main-purple text-pol-gray-2 border border-pol-light-purple-2 group-hover:border-pol-light-purple-3 group-hover:text-pol-dark-2 rounded-[0.625rem] min-w-[2.25rem] w-9 h-9 flex-center">
                                    <i className={iconClass}/>
                                </div>
                                {
                                    opened ?
                                        <span
                                            className="font-semibold text-sm text-pol-gray group-hover:text-pol-dark-2">{title}</span>
                                        : null
                                }
                            </NavLink>
                            {
                                opened ?
                                    <button className="w-7 h-7 flex items-center justify-end"
                                            onClick={() => setShowSubmenu(prevState => !prevState)}>
                                        <i className={`icon-down-arrow text-[0.438rem] duration-100 ${showSubmenu ? "" : "rotate-90"}`}/>
                                    </button>
                                    : null
                            }
                        </div>
                        <div className={`relative ${showSubmenu && opened ? "" : "hidden"}`}>
                            <div
                                className="h-[calc(100%+2rem)] absolute bg-pol-light-purple-2 w-px -top-3 right-[1.188rem]"/>
                            <ul>
                                {
                                    subMenu.map(item => (
                                        <li
                                            className="relative mt-5 first:mt-3 last:mb-2.5 "
                                            key={item.key}>
                                            <NavLink
                                                className={({isActive}) => `group flex items-center gap-x-2.5 w-full ${isActive ? "sub-active" : ""}`}
                                                to={item.url}>
                                                <div
                                                    className="bg-pol-light-purple-2 rounded-full w-2.5 h-2.5 mx-3.5 group-hover:bg-pol-dark duration-300"></div>
                                                <span
                                                    className="font-semibold text-sm text-pol-purple-3 group-hover:text-pol-dark duration-300">{item.title}</span>
                                            </NavLink>
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    </div> :
                    activeAccount || activeInMenu === null ?
                        <NavLink
                            className={({isActive}) => `group flex items-center gap-x-2.5 w-full ${isActive ? "active" : ""}`}
                            to={url}>
                            <div
                                className="border border-pol-light-purple-2 text-pol-gray-2 group-hover:border-pol-light-purple-3 group-hover:text-pol-dark-2 rounded-[0.625rem] min-w-[2.25rem] w-9 h-9 flex-center">
                                <i className={iconClass}/>
                            </div>
                            {
                                opened ? <span
                                    className="font-semibold text-sm text-pol-gray group-hover:text-pol-dark-2">{title}</span> : null
                            }
                        </NavLink> :
                        <div
                            className="flex-between w-full opacity-40 cursor-not-allowed">
                            <div className="flex items-center gap-x-2.5">
                                <div
                                    className="border border-pol-light-purple-2 text-pol-gray-2 rounded-[0.625rem] min-w-[2.25rem] w-9 h-9 flex-center">
                                    <i className={iconClass}/>
                                </div>
                                {
                                    opened ? <span className="font-semibold text-sm text-pol-gray">{title}</span> : null
                                }
                            </div>
                            {
                                opened ? <i className="icon-lock text-pol-gray"/> : null
                            }
                        </div>
            }
        </div>
    )
}
